import { render, staticRenderFns } from "./companyBusiness.vue?vue&type=template&id=395f7eb2&scoped=true&"
import script from "./companyBusiness.vue?vue&type=script&lang=js&"
export * from "./companyBusiness.vue?vue&type=script&lang=js&"
import style0 from "./companyBusiness.vue?vue&type=style&index=0&id=395f7eb2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395f7eb2",
  null
  
)

export default component.exports